export default {
    REGISTER_CODE_REQUEST: 'REGISTER_CODE_REQUEST',
    REGISTER_CODE_ERRORS: 'REGISTER_CODE_ERRORS', 

    RESET_PASSWORD_CODE_REQUEST: 'RESET_PASSWORD_CODE_REQUEST',
    RESET_PASSWORD_CODE_ERRORS: 'RESET_PASSWORD_CODE_ERRORS', 

    SEND_CODE_AGAIN: 'SEND_CODE_AGAIN',
};